import { render, staticRenderFns } from "./GridEvaluacion.vue?vue&type=template&id=31ae79b2&"
import script from "./GridEvaluacion.vue?vue&type=script&lang=js&"
export * from "./GridEvaluacion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports